<div class="oppsummering">
  <c3-todelt-pai [andel]="harSignert().length" [totalt]="signatarer().signatarer.length"
                 [konfig]="harIkkeSignert().length > 0 ? pieKonfigBlaa : pieKonfigGroenn"
                 bredde="18"/>
  <span>
    @if (harIkkeSignert().length > 0) {
      <!-- ikke luft mellom }} og @if for å unngå blankt tegn før komma-->
      {{ '{andel} av {totalt} har ikke signert'|translate: {andel: harIkkeSignert().length, totalt: signatarer().signatarer.length} }}@if (visSendPaaminnelse()) {,
         {{ 'påminnelse sendes om {antall} dager'|translate: {antall: signatarer().dagerTilNestePurring} }}
          <a (click)="sendPaaminnelse()">({{'send nå'|translate}})</a>
      }
    } @else {
      @switch (status()) {
        @case (statuser.signert) {
          {{ 'Alle har signert, avventer teknisk fullføring'|translate }}
        }
        @case (statuser.signertOgKonvoluttert) {
          {{ 'Alle har signert, teknisk/juridisk signaturdokumentasjon er generert'|translate }}
        }
        @case (statuser.eksterntSignert) {
          {{ 'En signert versjon av dokumentet har blitt lastet opp av en bruker' }}
        }
      }
    }
  </span>
</div>

<div data-testid="ikke-signert">
  @for (signatar of harIkkeSignert(); track signatar.medlem.id) {
    <medlem-listevisning-kompakt [medlem]="signatar.medlem">
      <span class="ikke-signert" data-testid="status">
        {{ 'Ikke signert'|translate }}
      </span>
    </medlem-listevisning-kompakt>
  }
</div>

<div data-testid="signert">
  @for (signatar of harSignert(); track signatar.medlem.id) {
    <medlem-listevisning-kompakt [medlem]="signatar.medlem">
      <span class="signert" data-testid="status">
        <mat-icon inline="true">signature</mat-icon>
        {{ 'Signert {dato}'|translate: {dato: signatar.signaturinformasjon!.signertDato|zoneddatetime} }}
      </span>
    </medlem-listevisning-kompakt>
  }
</div>
